import React from "react";
import Hamburger from "./hamburger";
import ThemeToggle from "./theme-toggle";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div className="topnav" id="header-background">
        <div className="navigation" id="myLinks">
          <Link to="/">
            <button id="navbtn" color="primary" size="sm">
              Home
            </button>
          </Link>

          <Link to="/about-me">
            <button id="navbtn" color="primary" size="sm">
              About me
            </button>
          </Link>

          <Link to="/work">
            <button id="navbtn" color="primary" size="sm">
              Work
            </button>
          </Link>
          <Link to="/blog">
            <button id="navbtn" color="primary" size="sm">
              Blog
            </button>
          </Link>
          <a
            href="https://github.com/iFrogHop2Worlds"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button id="navbtn" color="warning" size="sm">
              Github
            </button>
          </a>
          <Link to="/resume">
            <button id="navbtn" color="primary" size="sm">
              Resume
            </button>
          </Link>
          <ThemeToggle className="header-theme-toggle" />
        </div>

        <Hamburger />
      </div>
      <style>{`
        #myLinks {
          border-bottom: 1px solid #00ffff;
          display: flex;
          justify-content: center;
          
        }
  

        #navbtn {
          margin: 5px;
          background-color: #002549;
          color: white;
          font-size: 16px;
          font-family: 'Roboto Mono', monospace;
          opacity: 0.8;
          border-radius: 4px;
          width: 100px;
          
        }
        #navbtn:hover {opacity: 1; color: ghostwhite;}

        #header-background {
          background-color: black;
          {/* background-image: url("https://as2.ftcdn.net/v2/jpg/01/21/94/09/1000_F_121940968_O9M6zOz1EZAOQuzGTfn8aYBbhaIAVNjj.jpg"); */}
          bCkground-size: 10%, 10%;
          position: fixed;
          top: 0;
          width: 100%;
          z-index:1;
        }

        @media only screen and (max-width: 800px) {
          #myLinks {
            display: none;

        }
        }

      `}</style>
    </>
  );
};

export default Header;
